var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.XYZSource = new Class({
    Extends: OCS.Viewer.Classes.AbstractSource,
    class_name: "XYZSource",
    options: {
        metadata: {
            source_type: 'XYZ',
        }
    },
    create: function (options) {
        if (!this.get_ol_object()) {
            this.set_ol_object(new ol.source.XYZ(this.get_source_ops(options)));
            this.data_source_ready();
        }
        return this.get_ol_object();
    },
    get_source_ops: function (options) {
        var ops = {
            //crossOrigin: 'anonymous',
        };
        if (this.options.init.hasOwnProperty('urls')) {
            ops.urls = this.options.init.urls;
        }
        if (options && options.hasOwnProperty('urls')) {
            ops.urls = options.urls;
        }
        if (this.options.init.hasOwnProperty('url')) {
            ops.url = this.options.init.url;
        }
        if (options && options.hasOwnProperty('url')) {
            ops.url = options.url;
        }

        return ops;
    },
});
